import { CheckoutFinanceRate } from '../constants';

export const formatDuration = (rate: CheckoutFinanceRate): string => {
  const { type, duration, deferredDuration } = rate;

  const isBuyNowPayLater = type === 'BUYNOW_PAYLATER';

  if (isBuyNowPayLater) return `${deferredDuration} + ${duration} months`;

  const durationNumber = Number(duration);
  if (durationNumber < 12) return `${duration} months`;
  if (durationNumber === 12) return '1 year';
  return `${Math.round((durationNumber * 10) / 12) / 10} years`;
};
